/**
 * Gets current time
 * @returns {number}
 */
export const getCurrentTime = () => Math.floor(Date.now() / 1000);
